// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 类型
  getBusinessList(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/business/getBusinessList', params)
  },
  insertOrUpdate(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/business/insertOrUpdate', params)
  },
  getBusinessListTree(params) {
    return http.requestPost(apiPre + service.res + '/res/business/getBusinessListTree', params)
  },
  deteteByBusinessId(params) {
    return http.requestGet(apiPre + service.res + '/res/business/deteteByBusinessId/'+ params)
  },
 }



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/businessApi.js